<template>
  <div style="min-width: 90%">
    <h1 class="grey--text text--darken-2">{{ isNaN(this.$route.params.id) ? 'Новая рассылка' : 'Редактирование рассылки' }}</h1>

    <v-form>
      <v-row>
        <v-col cols="10" class="pb-0">
          <v-text-field
            v-model.trim="form.mailing_name"
            autofocus
            prepend-icon="mdi-mail"
            hint="Название"
            persistent-hint
            :error-messages="verrMailingName"
            @input="$v.form.mailing_name.$touch()"
            @blur="$v.form.mailing_name.$touch()"/>
        </v-col>
        <v-col class="pb-0">
          <v-menu
            ref="menu"
            v-model="datepicker"
            :close-on-content-click="false"
            transition="scale-transition"
            max-width="290px"
            offset-y>
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="form.mailing_date"
                hint="Дата рассылки"
                persistent-hint
                readonly
                :error-messages="verrMailingDate"
                @input="$v.form.mailing_date.$touch()"
                @blur="$v.form.mailing_date.$touch()"
                v-on="on"/>
            </template>
            <v-date-picker
              v-model="form.mailing_date"
              :min="minDate"
              :max="maxDate"
              :reactive="false"
              no-title
              locale="uk"
              @change="datepicker=false; loadUnused()"
              scrollable>
            </v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="10" class="pt-0 pb-0">
          <v-autocomplete v-model="form.spot_id"
            :items="spots4select"
            :disabled="!!items.length"
            prepend-icon="mdi-palette-advanced"
            hint="Рекламный инструмент"
            persistent-hint
          />
        </v-col>
        <v-col class="pt-0 pb-0">
          <v-text-field
            v-model="form.mailing_time"
            type="time"
            hint="Время рассылки"
            persistent-hint
            clearable/>
         </v-col>
      </v-row>
      <v-row>
        <v-col cols="10" class="pt-0 pb-0">
          <v-text-field
            v-model.trim="form.mailing_subject"
            autofocus
            prepend-icon="mdi-email-outline"
            hint="Тема письма"
            persistent-hint
            @input="$v.form.mailing_name.$touch()"
            @blur="$v.form.mailing_name.$touch()"/>
        </v-col>
        <v-col>
          <v-tooltip v-if="form.mailing_planfix_task" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs" v-on="on"
                text small
                target="_blank" :href="'https://apteka911.planfix.ua/task/'+form.mailing_planfix_task">
                  <v-icon color="#71a32e" class="mr-1">mdi-alpha-p-circle</v-icon>
                  {{ form.mailing_planfix_task }}
              </v-btn>
            </template>
            <span>Перейти к задаче рассылки в ПланФикс</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <div v-if="form.mailing_id" class="mt-7">
        <h3 class="grey--text text--darken-2">Участвующие юниты</h3>

        <v-simple-table v-if="items.length" dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-center" style="width: 40px"><v-icon>mdi-delete</v-icon></th>
                <th class="text-left">Контрагент</th>
                <th class="text-left">Бренд</th>
                <th class="text-left">Юнит</th>
                <th class="text-right" style="width: 100px">Кол-во</th>
                <th class="text-center" style="width: 135px">Статус</th>
                <th class="text-center" style="width: 90px">Planfix</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, key) in items" :key="`item-${key}`">
                <td><v-simple-checkbox :ripple="false" v-model="items[key].selected"></v-simple-checkbox></td>
                <td :style="items[key].selected ? 'text-decoration: line-through' : ''">{{ item.companyName }}</td>
                <td :style="items[key].selected ? 'text-decoration: line-through' : ''">{{ item.brandName }}</td>
                <td :style="items[key].selected ? 'text-decoration: line-through' : ''">{{ item.uitemName }}</td>
                <td class="text-right">{{ item.uitemQnt }}</td>
                <td class="text-center">{{ statuses[item.uitemStatus] }}</td>
                <td class="text-center">
                  <span v-if="item.uitemPlanfixTask" style="color: #61a038; cursor: pointer" @click="goPlanfixAction(item.uitemPlanfixTask)">{{ item.uitemPlanfixTask }}</span>
                  <span v-else class="grey--text text--lighten-1">&mdash;</span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <p v-else class="grey--text font-italic">юниты отсутствуют</p>
      </div>

      <div v-if="['draft', 'planned'].includes(form.mailing_status)" class="mt-7">
        <h3 class="grey--text text--darken-2 mt-5">Доступные юниты</h3>

        <v-simple-table v-if="unused.length" dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-center" style="width: 40px"><v-icon>mdi-plus-thick</v-icon></th>
                <th class="text-left">Контрагент</th>
                <th class="text-left">Бренд</th>
                <th class="text-left">Юнит</th>
                <th class="text-right" style="width: 100px">Кол-во</th>
                <th class="text-center" style="width: 135px">Статус</th>
                <th class="text-center" style="width: 90px">Planfix</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, key) in unused" :key="`item-${key}`">
                <td><v-simple-checkbox :ripple="false" v-model="unused[key].selected"></v-simple-checkbox></td>
                <td>{{ item.companyName }}</td>
                <td>{{ item.brandName }}</td>
                <td>{{ item.uitemName }}</td>
                <td class="text-right">{{ item.uitemQnt }}</td>
                <td class="text-center">{{ statuses[item.uitemStatus] }}</td>
                <td class="text-center">
                  <span v-if="item.uitemPlanfixTask" style="color: #61a038; cursor: pointer" @click="goPlanfixAction(item.uitemPlanfixTask)">{{ item.uitemPlanfixTask }}</span>
                  <span v-else class="grey--text text--lighten-1">&mdash;</span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <p v-else-if="!form.mailing_date" class="grey--text font-italic">выберите дату рассылки</p>
        <p v-else class="grey--text font-italic">нет доступных юнитов в этом месяце</p>
      </div>

      <v-card-actions class="mt-3">
        <v-btn
          raised
          @click="cancelAction" class="mr-3">Отмена</v-btn>
        <v-btn
          type="submit"
          raised
          color="primary"
          :loading="loading"
          :disabled="$v.$invalid"
          @click.prevent="submitAction">Сохранить</v-btn>
      </v-card-actions>

    </v-form>

  </div>
</template>

<script>
import api from '@/api'
import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'
import { microunitStatuses } from '@/common'

export default {
  mixins: [ validationMixin ],
  data: () => ({
    loading: false,
    datepicker: false,
    timepicker: false,
    form: { },
    spots: [],
    items: [],
    unused: [],
    statuses: microunitStatuses.reduce((acc, cur) => (acc[cur.value] = cur.text, acc), {})
  }),
  validations: {
    form: {
      mailing_name: { required, minLength: minLength(3) },
      spot_id: { required },
      mailing_date: { required },
    }
  },
  computed: {
    minDate () {
      return this.form.mailing_id && this.form.mailing_date && this.items.length ? this.form.mailing_date.substr(0, 8)+'01' : new Date().toISOString().substr(0, 8)+'01'
    },
    maxDate () {
      return this.form.mailing_id && this.form.mailing_date && this.items.length ? this.form.mailing_date.substr(0, 8)+'31' : false
    },
    spots4select () {
      return this.spots.reduce((acc, cur) => (acc.push({ value: cur.spotID, text: cur.spotName}), acc), [])
    },
    verrMailingName () {
      return !this.$v.form.mailing_name.$dirty ? [] :
        !this.$v.form.mailing_name.minLength ? 'Минимум 3 символа' :
        !this.$v.form.mailing_name.required ? 'Введите название' : []
    },
    verrMailingDate () {
      return !this.$v.form.mailing_date.$dirty ? [] :
        !this.$v.form.mailing_date.required ? 'Выберите дату' : []
    },
    verr_spot_id () {
      return !this.$v.form.spot_id.$dirty ? [] :
        !this.$v.form.spot_id.required ? 'Выберите рекламный инструмент' : []
    }
  },
  mounted: function () {
    this.load()
  },
  methods: {
    load () {
      this.loading = true
      if ( isNaN(this.$route.params.id) )
        api.get('mailings/spots').then(response => {
          this.loading = false;
          this.spots = response.data.data.spots
        }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
      else
        api.get('mailings/get/'+this.$route.params.id).then(response => {
          this.loading = false;
          if ( response.data.result !== 'ok' ) return this.$root.$alert(response.data.data, true)
          this.form = response.data.data.mailing
          this.items = response.data.data.items
          this.unused = response.data.data.unused
          this.spots = response.data.data.spots
        }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    },
    loadUnused () {
      if ( !this.form.mailing_date || !this.form.spot_id )
        return this.unused = []

      api.get('mailings/unused/'+this.form.mailing_date+'/'+this.form.spot_id).then(response => {
        if ( response.data.result !== 'ok' ) return this.$root.$alert(response.data.data, true)
        this.unused = response.data.data.unused
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    },
    cancelAction () {
      this.$router.go(-1)
    },
    goPlanfixAction (planfixTask) {
      window.open('https://apteka911.planfix.ua/task/'+planfixTask)
    },
    submitAction () {
      if ( this.$v.$error ) return
      let request = Object.assign({}, this.form, {
        add: this.unused.reduce((acc, cur) => (cur.selected ? acc.push(cur.uitemID) : 0, acc), []),
        del: this.items.reduce((acc, cur) => (cur.selected ? acc.push(cur.uitemID) : 0, acc), [])
      })
      let action = this.form.mailing_id ? 'update/'+this.$route.params.id : 'create';
      this.loading = true
      api.post('mailings/'+action, request).then(response => {
        this.loading = false;
        if ( response.data.result !== 'ok' ) return this.$root.$alert(response.data.data, true)
        this.$root.$alert('Рассылка сохранена')
        this.$router.go(-1)
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    }
  }
}
</script>

<style>
.v-list-item { min-height: 30px }
.v-list-item__content { padding: 0; }
.v-list-item__title { font-size: 0.92rem; }

.v-subheader { height: 30px; padding-left: 8px; letter-spacing: 2px; margin-top: 4px; }
</style>
